module.exports = __webpack_public_path__ + "img/10.76ee71a4.png";